import * as Dialog from '@radix-ui/react-dialog';

import { cn } from '~/chords/lib/cn';
import { renderSlot } from '~/chords/utils/renderSlot';

import { CONTENT_CLASS, OVERLAY_CLASS } from '../constants';
import type { SlideOutContentProps } from '../types';
import { SlideOutBody } from './SlideOutBody';
import { SlideOutFooter } from './SlideOutFooter';
import { SlideOutHeader } from './SlideOutHeader';

export function SlideOutContent({
  overlayRef,
  contentRef,
  panelWidth,
  children,
  ...props
}: SlideOutContentProps) {
  return (
    <Dialog.Portal>
      <Dialog.Overlay
        ref={overlayRef}
        className={cn('fixed inset-0 z-20 bg-overlay', OVERLAY_CLASS.show)}
        role="none"
      />
      <Dialog.Content
        {...props}
        ref={contentRef}
        className={cn(
          'fixed inset-y-0 right-0 z-30',
          'border-l bg-level-02 border-l-emphasis-subtle',
          'flex max-w-full flex-col text-default',
          'duration-300 ease-out',
          'shadow-xl drop-shadow-xl',
          CONTENT_CLASS.show,
          props.className,
        )}
        style={{ transform: `translateX(${panelWidth})`, width: panelWidth }}
        aria-describedby={undefined}
        // Don't close the SlideOut when interacting with a Toast notification.
        onInteractOutside={(event) => {
          if ((event.target as HTMLElement).closest('[data-sonner-toaster]')) {
            event.preventDefault();
          }
        }}
      >
        {renderSlot(SlideOutHeader, children)}
        {renderSlot(SlideOutBody, children)}
        {renderSlot(SlideOutFooter, children)}
      </Dialog.Content>
    </Dialog.Portal>
  );
}

SlideOutContent.displayName = 'SlideOut.Content';
